import { ThemeModeProvider, Toaster } from "@vv/ui";
import { store } from "@vv/state";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "./router/AppRouter";

export default function App() {
  return (
    <Provider store={store}>
      <ThemeModeProvider>
        <Toaster />
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </ThemeModeProvider>
    </Provider>
  );
}
